/** Создание кнопки показа пароля для редактора dxTextBox.
 *  @returns {object} настройки кнопки. */
export function makePasswordViewButton() {
    return {
        name: 'password-view',
        options: {
            elementAttr: {
                class: 'ksa-password-view'
            },
            icon: 'login-password-masked',
            activeStateEnabled: true,
            focusStateEnabled: false,
            hoverStateEnabled: false,
            stylingMode: 'text',
            width: 56,
            height: 56,
            onInitialized: function(e) {
                const showPassword = function(value) {
                    const button = e.component;
                    const editor = e.element.closest('.ksa-password-editor').dxTextBox('instance');
                    if (editor) {
                        button.option('icon', value ? 'login-password-visible' : 'login-password-masked');
                        editor.option('mode', value ? 'text' : 'password');
                    }
                };

                e.element.on('dxactive',   function() { showPassword(true);  });
                e.element.on('dxinactive', function() { showPassword(false); });
            }
        },
        widget: 'dxButton'
    };
}
